Vue.component("YoutubeVideoEmbed", {
    props: ["config"],
    template: `
    
        <div class="videoEmbed">

            <iframe 
                width="100%" 
                height="100%" 
                :src="config.src" 
                frameborder="0" 
                allow="autoplay;"></iframe>
        </div>


    `
});